import { SeatType } from '@vista-digital/ocapi-types/v1';
export function getAppearanceForSeat(seatType, isAvailable, isSelected, isFriend, isHouse, appearance, customAppearance) {
    const seatAppearanceStates = getAppearanceStatesForSeatType(appearance, seatType, isFriend);
    const appearanceForState = getAppearanceForState(seatAppearanceStates, isAvailable, isSelected, isHouse);
    const customAppearanceForState = getAppearanceForState(customAppearance, isAvailable, isSelected, isHouse);
    return Object.assign(Object.assign(Object.assign(Object.assign({}, appearance.default), appearanceForState), customAppearance === null || customAppearance === void 0 ? void 0 : customAppearance.default), customAppearanceForState);
}
function getAppearanceStatesForSeatType(appearance, seatType, isFriend) {
    if (isFriend) {
        return appearance.friend;
    }
    switch (seatType) {
        case SeatType.Wheelchair:
            return appearance.wheelchair;
        case SeatType.Companion:
            return appearance.companion;
        case SeatType.SofaLeft:
            return appearance.sofaLeft;
        case SeatType.SofaMiddle:
            return appearance.sofaMiddle;
        case SeatType.SofaRight:
            return appearance.sofaRight;
        default:
            return appearance.normal;
    }
}
function getAppearanceForState(appearancesByState, isAvailable, isSelected, isHouse) {
    if (appearancesByState === undefined)
        return undefined;
    if (isHouse) {
        return Object.assign(Object.assign(Object.assign({}, appearancesByState.default), appearancesByState.unavailable), appearancesByState.house);
    }
    if (!isAvailable)
        return Object.assign(Object.assign({}, appearancesByState.default), appearancesByState.unavailable);
    if (isSelected)
        return Object.assign(Object.assign({}, appearancesByState.default), appearancesByState.selected);
    return appearancesByState.default;
}
